module.exports = __webpack_public_path__ + "static/img/zs001.ceab9e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs001.jpg
// module id = QtWJ
// module chunks = 13